import { render, staticRenderFns } from "./payfor-balance.vue?vue&type=template&id=3239911b&"
import script from "./payfor-balance.vue?vue&type=script&lang=js&"
export * from "./payfor-balance.vue?vue&type=script&lang=js&"
import style0 from "./payfor-balance.vue?vue&type=style&index=0&id=3239911b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports